export default "/_next/static/images/bdac2e482e1edc0d14334c8d9894d3bd.jpg";